// ABOUTME: Admin route wrappers that extract params for nested admin pages.
// ABOUTME: Provides proper workspaceId from URL params to child components.

import { useParams } from 'react-router-dom';
import { AgentConfigPanel } from './AgentConfigPanel';
import { UsageAnalytics } from './UsageAnalytics';

export function AgentConfigPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <div>Workspace ID required</div>;
  return <AgentConfigPanel workspaceId={id} />;
}

export function UsageAnalyticsPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <div>Workspace ID required</div>;
  return <UsageAnalytics workspaceId={id} />;
}
